export default class TimeTiebreaker {
  public timeTiebreaker: boolean = false;
}
